import { Core } from '../../Constants';
import { rdf, rdfs } from '../../Vocabs';
export function Mixin(Base) {
    class RdfProperty extends Base {
        get range() {
            return this.get(rdfs('range'));
        }
        get domain() {
            return this.get(rdfs('domain'));
        }
        get supportedOperations() {
            return this.getArray(Core.Vocab('supportedOperation'));
        }
        get isLink() {
            return this.types.contains(Core.Vocab('Link'));
        }
    }
    return RdfProperty;
}
export const shouldApply = (res) => res.types.contains(rdf.Property);
//# sourceMappingURL=RdfProperty.js.map